/* @flow */
import * as React from "react";
import SpinnerOverlay from "nexia_mobile/components/SpinnerOverlay";
import connect from "nexia_mobile/flux_like/store/connect";

type Props = {
  spinnerShown: boolean,
  spinnerMessage: ?string,
};

class GlobalBlockingSpinner extends React.Component<Props> {
  render() {
    const { spinnerShown, spinnerMessage } = this.props;
    if (!spinnerShown) {
      return null;
    }
    return <SpinnerOverlay message={spinnerMessage} />;
  }
}

export default connect(
  { spinnerShown: "spinnerShown", spinnerMessage: "spinnerMessage" },
  GlobalBlockingSpinner
);



// WEBPACK FOOTER //
// ./src/components/GlobalBlockingSpinner.jsx